import React from "react";

import { BrandTileClickImpressionProvider } from "./__internal__/BrandTileClickImpressionProvider";
import { BrandTileViewImpressionProvider } from "./__internal__/BrandTileViewImpressionProvider";
import { ImpressionProviderProps } from "./__internal__/ImpressionProviderProps";

export const BrandTileImpressionTrackingWrapper: React.FC<
  React.PropsWithChildren<ImpressionProviderProps>
> = ({ children, ...rest }) => {
  return (
    <BrandTileViewImpressionProvider {...rest}>
      <BrandTileClickImpressionProvider {...rest}>
        {children}
      </BrandTileClickImpressionProvider>
    </BrandTileViewImpressionProvider>
  );
};
